export enum ActivitiesTab {
  DONE = 'done',
  PLANNED = 'planned',
  AUTOMATIC = 'automatic',
  VERIFIED = 'verified',
}

//Todo: rename to ActivitiesAggregationType
export enum ActivitiesViewType {
  SINGLE = 'single',
  GROUPED = 'grouped',
}

export enum ActivitiesVerification {
  PENDING = 'pending',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
}

export enum ActivitiesStatus {
  DONE = 'done',
  TODO = 'todo',
  EXPIRED = 'expired',
}

export enum ActivitiesCompletionStatus {
  DONE = 'DONE',
  PLANNED = 'PLANNED',
}
